import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = import.meta.env.VITE_HOST_API;
export const ASSETS_API = import.meta.env.VITE_ASSETS_API;
// Origen del servicio AmbirScanWebConnect local. El respaldo NO es un adorno:
// sin él, una variable ausente se interpola como la cadena "undefined" y axios
// toma "undefined/ambirscanwebconnect" por una baseURL RELATIVA, que resuelve
// contra la página actual (p.ej. /medicore/configuration/undefined/...). La
// petición nunca sale hacia el servicio y el SPA responde su propio index.html:
// un 404 mudo imposible de atribuir a la configuración. Con el respaldo, el
// peor caso es un error de red honesto contra el puerto correcto, que
// toScannerError ya traduce a "verifique que AmbirScanWebConnect esté corriendo".
export const AMBIR_API = import.meta.env.VITE_AMBIR_SCANNER_PORT || 'https://localhost:53051';
// El OCR de documentos se consume a través del backend (api/Ocr/scan): su host está en la
// VLAN interna y su API key es un secreto de servidor. No exponer aquí ninguna URL suya.
export const PRODUCTION = import.meta.env.VITE_PRODUCTION;
export const TEST_USER_USERNAME = import.meta.env.VITE_TEST_USER_USERNAME;
export const TEST_USER_PASSWORD = import.meta.env.VITE_TEST_USER_PASSWORD;

export const HUBS_API = {
  inventory: import.meta.env.VITE_INVENTORY_HUB,
  products: import.meta.env.VITE_PRODUCTS_HUB,
  spaces: import.meta.env.VITE_SPACES_HUB,
};

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: import.meta.env.VITE_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: import.meta.env.VITE_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  callbackUrl: import.meta.env.VITE_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = import.meta.env.VITE_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.medicore.root; // as '/dashboard'
export const PATH_AFTER_PATIENT_LOGIN = '/patient/patient-portal/digital-report'; // as '/patient/patient-portal/digital-report'
// Contenedor CIE-11 de la OMS autoalojado. Los respaldos evitan el mismo fallo que AMBIR_API:
// una variable ausente se interpola como la cadena "undefined", la URL queda RELATIVA y el SPA
// devuelve su propio index.html — un 404 mudo imposible de atribuir a la configuración.
export const ICD_API = import.meta.env.VITE_ICD_API || 'https://grumeba.com.do/icd/api';
export const ICD_VERSION = import.meta.env.VITE_ICD_VERSION || '2025-01';
export const ICD_API_LANGUAGE = import.meta.env.VITE_ICD_API_LANGUAGE;
